import portfolio1 from './portfolio1.webp'
import portfolio2 from './portfolio2.webp'
import portfolio3 from './portfolio3.webp'
import portfolio4 from './portfolio4.webp'
import portfolio5 from './portfolio5.webp'
import portfolio6 from './portfolio6.webp'
import portfolio7 from './portfolio7.webp'

const array = [
	{
		title: 'Лэндинг страница',
		image: portfolio1,
	},
	{
		title: 'Портфолио',
		image: portfolio2,
	},
	{
		title: 'Digital product',
		image: portfolio3,
	},
	{
		title: 'Green-cube',
		image: portfolio4,
	},
	{
		title: 'Fundo',
		image: portfolio5,
	},
	{
		title: 'furni.shop',
		image: portfolio6,
	},
	{
		title: 'Toste',
		image: portfolio7,
	},
]

export default array
